module.exports = __webpack_public_path__ + "static/media/midia_mock4.85da7f5d.jpg";